module.exports = __webpack_public_path__ + "static/img/06.4fcf737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/06.jpg
// module id = IRhf
// module chunks = 0